"use strict";
import { createContext } from "react";
export const AuthTokenContext = createContext({
  authToken: null
});
AuthTokenContext.displayName = "AuthTokenContext";
